import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
import EntityPathNamesValue from 'components/EntityPathNamesValue';
// @ts-ignore
import { makeSelectEventValue } from 'services/events/selectors';

interface OwnProps {
    eventId: number;
}

interface ConnectedProps {
    entityId?: number | undefined;
}

type Props = OwnProps & ConnectedProps;

export class EventEntityHierarchyComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { entityId } = this.props;
        return <EntityPathNamesValue entityId={entityId} />;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    entityId: makeSelectEventValue('entityId')
});

export default connect(mapStateToProps)(EventEntityHierarchyComponent);
